export const USER_BONUS_TABLE_PT_BR = {
	title: "Bônus",
	total: "Total de {{category}}",
	noCategory: "Sem categoria",
	columns: {
		total: "Total",
		employee: "Colaborador",
		client: "Cliente",
		date: "Data",
		reason: "Motivo",
		category: "Categoria",
		receivedValue: "Valor recebido",
		spentValue: "Valor gasto no período",
		spentValueInOtherEvents: "Valor gasto em outro período",
	},
	minimumConsumptionReport: {
		title: "Consumação antecipada",
	},
	filenameBonus: "bonus-concedido",
	filenameAnticipated: "consumacao-antecipada",
	filenameConsumption: "consumacao",
	filterCategoryPlaceholder: "Selecione uma categoria",
	filterEmployeePlaceholder: "Filtrar por colaborador",
	categoryNotFound: "Nenhuma categoria encontrada",
	exportToExcelButton: "Exportar para excel",
};

export type UserBonusTableTranslations = typeof USER_BONUS_TABLE_PT_BR;
